import {formActions} from '@/enums/formActions'
import {mapFilters} from "@/utils/helpers";

const initState = () => ({
  customer: {},
  customerSettings: {},
  resetCustomerAfterOrderEntry: false
})

export const state = initState

export const getters = {
  getCustomerId(state){
    return state.customer?.id;
  }
}

export const mutations = {
  setCustomerDatas(state, {customer}) {
    if(customer){
      state.customer = customer;
    }
    else{
      state.customer = {}
    }
  },
  unselectCustomer(state) {
    state.customer = {}
  },
  incCustomerWishlistItemCount(state){
    state.customer.wishlistItemCount += 1
  },
  descCustomerWishlistItemCount(state){
    state.customer.wishlistItemCount -= 1
  },
  setCustomerSettings(state,{customerSettings}){
    state.customerSettings = customerSettings
  },
  setCustomerCurrencySettings(state, {customer}){
    state.customer.customerCurrencyIsDifferentFromSystemCurrency = customer.customerCurrencyIsDifferentFromSystemCurrency
    state.customer.exchangeRate = customer.exchangeRate
    state.customer.currencySymbol = customer.currencySymbol
    state.customer.exchangeDate = customer.exchangeDate
  },
  setCustomerHasSameShipping(state, {value}){
    this.state.customer.hasSameShippingInfo = value;
  },
  setResetCustomerAfterOrderEntry(state, {value}){
    state.resetCustomerAfterOrderEntry = value;
  }
}

export const actions = {
  async updateCustomer({commit}, {customer}) {
    await this.$catch(
      async () => {
        await this.$axios.$put(`webpos/customer/updateCustomerContactDatas/${customer.id}`, customer)
          .then((result) => {
          if(!result.hasErrors){
            this.$toast.success("Customer updated successfully");
          }
          else{
            this.$toast.error(result.errorMessages[0].value);
          }

        }).catch((result) => {
          this.$toast.error(result.message);
        });
      },
      formActions.Save
    );
  },

  loadCustomer({commit, dispatch}, customerId){
    this.$catch(
      async () => {
        let result = await this.$axios.$get(`webpos/customer/getCustomerContactData/${customerId}`, {
          id: customerId,
        });

        if (!result.hasErrors) {
          let apiCustomer = await dispatch('convertCustomer', {customer: result.value, address: result.value.address, shippingMethod: result.value.shippingMethod})
          apiCustomer.wishlistItemCount = result.value.wishlistItemCount > 0 ? result.value.wishlistItemCount : 0
          commit('setCustomerDatas', {customer: apiCustomer});
        } else {
          this.$toast.error('Error while selecting the customer');
        }
      });
  },

  async insertNotes({commit}, {customerId, notes}){
    const result = await this.$axios.$post(`webpos/customer/insert-notes/${customerId}`, notes)
    try{
      if (result && !result.hasErrors){
        this.$toast.success("Customer notes inserted successfully");
      }
      else {
        this.$toast.error('Error while inserting notes for customer');
      }
    }
    catch(e){
      this.$toast.error('Error while inserting notes for customer');
    }
  },

  async updateNote({commit}, {note}){
    try{
      const result = await this.$axios.$post(`webpos/customer/update-note`, note)
      if (result && !result.errorMessage){
        this.$toast.success("Customer note updated successfully");
      }
      else {
        this.$toast.error("Error while updating note for customer");
      }
    }
    catch(e){
      this.$toast.error("Error while updating note for customer");
    }
  },

  async insertEvent({dispatch}, {event, customerId}){
    const convertedEvent = await dispatch('convertEvent', {event: event, customerId: customerId});
    const result = await this.$axios.$post(`webpos/customer-event/insert-event`, convertedEvent);
    if (result && !result.hasErrors) {
      if(event.id){
        this.$toast.success("Event updated successfully!");
      }
      else{
        this.$toast.success("Event inserted successfully!");
      }
    }
    else {
      if(event.id){
        this.$toast.error('Error while updating event!');
      }
      else{
        this.$toast.error('Error while inserting event!');
      }
    }
  },
  async insertEvents({dispatch}, {events}){
    const result = await this.$axios.$post(`webpos/customer-event/insert-events`, events);
    try{
      if (result && !result.hasErrors) {
        this.$toast.success("Events inserted successfully!");
      }
      else {
        this.$toast.error('Error while inserting events!');
      }
    }
    catch (ex) {
      this.$toast.error('Error while inserting events!');
    }
  },

  async getCustomerEventByCustomerId({commit}, {customerId, pagingInfo}){
    const filter = {
      customerId: customerId,
      pageNo: pagingInfo.pageNo,
      pageSize: pagingInfo.pageSize,
      sortBy: pagingInfo.sortBy,
      sortAsc: pagingInfo.sortAsc
    }
    let result = await this.$axios.post(`webpos/customer-event/by-customer`, filter);
    if (result && !result.data.hasErrors) {
      return result.data;
    } else {
      this.$toast.error("Error while getting customer events");
      return null;
    }
  },
  async deleteEvent({commit}, {eventId}){
    const result = await this.$axios.$delete(`webpos/customer-event/${eventId}`)
    if(result && !result.hasErrors){
      this.$toast.success("Event deleted successfully!");
    }
    else{
      this.$toast.error("Error while deleting event!");
    }
  },
  async getCustomerContactData({commit, dispatch}, customerId){
    let result = await this.$axios.$get(`webpos/customer/getCustomerContactData/${customerId}`)
    if(result && !result.hasErrors) {
      commit('setCustomerCurrencySettings', {customer: result.value});
      return await dispatch('convertCustomer', {customer: result.value, address: result.value.address, shippingMethod: result.value.shippingMethod})
    }
    else {
      this.$toast.error('Error while selecting the customer!');
      return null;
    }
  },
  async getCustomerSettings({commit}){
    let result = await this.$axios.$get(`webpos/customer/get-customer-settings`)
    if (result.hasErrors){
      this.$toast.error("Error while getting customer settings");
    }
    else
    {
      commit('setCustomerSettings', {customerSettings: result.value});
    }
  },
  async convertCustomer({commit}, {customer, address, shippingMethod}){
    return {
      id: customer.id,
      usID: customer.customerUSID,
      name: customer.companyName || `${customer.firstName} ${customer.lastName}`,
      firstName:  customer.companyName || customer.firstName,
      lastName: customer.lastName || '',
      categoryID: customer.categoryID,
      email: customer.email,
      phone:  customer.phone,
      contactFirstName: (customer.companyName && customer.contactFullName.split(' ').length > 1) ? customer.contactFullName.split(' ')[0] : '',
      contactLastName:  (customer.companyName && customer.contactFullName.split(' ').length > 1) ? customer.contactFullName.split(' ')[1] : '',
      addressID: customer.address && customer.addressID || '',
      address: address && address.addressName || '',
      address1: address && address.addressLine1 || '',
      address2: address && address.addressLine2 || '',
      countryID: address && address.countryID || '',
      stateID: address && address.stateID || '',
      country: address && address.country || '',
      city: address && address.city || '',
      state: address && address.state || '',
      zip: address && address.zip || '',
      wishlistItemCount: 0,
      companyName: customer.companyName,
      customerCurrencyIsDifferentFromSystemCurrency: customer.customerCurrencyIsDifferentFromSystemCurrency,
      currencySymbol: customer.currencySymbol,
      exchangeRate: customer.exchangeRate,
      exchangeDate: customer.exchangeDate,
      currencyID: customer.currencyId || 0,
      hasSameShippingInfo: customer.hasSameShippingInfo,
      customerTypeID: customer.customerTypeID,
      useRetailPrices: customer.useRetailPrices,
      shippingMethod: shippingMethod && shippingMethod.itemTypeID > 0 ? shippingMethod : null,
      parentCustomerID: customer.parentCustomerID || 0,
      calculateSalesTaxBasedOnShippingAddress : customer.calculateSalesTaxBasedOnShippingAddress,
      locationName: customer.locationName || null,
    }

  },
  async convertEvent({},{event, customerId}){
    if(event){
      return {
        customerId: customerId,
        name: event.name,
        relatedCustomerId: event.relatedCustomer,
        relationship: event.relationship.value,
        eventType: event.eventType.value,
        isRecurring: event.isRecurring,
        month: event.month.value,
        day: event.day,
        year: event.year || null,
        includeInReport: event.includeInReport,
        id: event.id || null
      }
    }
  },
  async getCustomerShippingAddressesByCustomerId({commit}, {customerId, pagingInfo}){
    const filter = {
      customerId: customerId,
      pageNo: pagingInfo.pageNo,
      pageSize: pagingInfo.pageSize,
      sortBy: pagingInfo.sortBy,
      sortAsc: pagingInfo.sortAsc
    }
    let result = await this.$axios.post(`webpos/customer/shipping-addresses-by-customer`, filter);
    if (result && !result.data.hasErrors) {
      return result.data;
    } else {
      this.$toast.error("Error while getting customer shipping addresses");
      return null;
    }
  },
  async insertCustomerShipping({dispatch}, {address, customerId}){
    address.customerId = customerId;
    let isActionSuccessful = false;
    try {
      const result = await this.$axios.$post(`webpos/customer/save-shipping-addresses`, address);
      if (result && !result.apiMessages.hasErrors) {
        if(address.id){
          this.$toast.success("Shipping address updated successfully!");
        }
        else{
          this.$toast.success("Shipping address inserted successfully!");
        }
        isActionSuccessful = true
      }
      else {
        this.$toast.error(result.apiMessages.serverErrors[0].replace(/</g, "&lt;").replace(/>/g, "&gt;"));
      }
    }
    catch (ex) {
      this.$toast.error(ex);
    }
    return isActionSuccessful;
  },
  async deleteShippingAddress({commit}, {address}){
    try {
      const result = await this.$axios.$post(`webpos/customer/delete-shipping-address`, address);
      if(result && !result.apiMessages.hasErrors){
        this.$toast.success("Shipping address deleted successfully!");
      }
      else{
        this.$toast.error("Error while deleting shipping address!");
      }
    }catch (ex){
      this.$toast.error(ex);
    }

  },

  async checkCustomerIsActive({commit},customerID){
    try{
      return await this.$axios.$get(`webpos/customer/${customerID}/check-customer-is-active`);
    }catch(ex){
      this.$toast.error(ex);
    }
  },

  async fetchCustomerListItems({commit, dispatch}, {filters, pagingInfo}){
    let customerListItems = [];
    try{
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);
      let result = await this.$axios.$get(`webpos/customer/customer-list?${new URLSearchParams(filter).toString()}`);
      if (result && !result.hasErrors) {
        customerListItems = result;
      }
      else{
        this.$toast.error("Error while getting customer list items");
      }
    }
    catch{
      this.$toast.error("Error while getting customer list items");
    }
    return customerListItems;
  },

  async getCustomerMainInformation({},customerId){
    let customerMainInformation = {}
    try{
      let result = await this.$axios.$get(`webpos/customer/getCustomerContactData/${customerId}`)
      if(result && !result.hasErrors){
        customerMainInformation = result.value;
      }
      else{
          this.$toast.error("Error while getting customer main information");
      }
    }
    catch{
        this.$toast.error("Error while getting customer main information");
    }
    return customerMainInformation;
  },

  async fetchCustomerCreditCards({},customerId){
    let creditCardList = []
    try{
      creditCardList = this.$axios.$get(`/webpos/customer/${customerId}/credit-cards/gateway/0`)
      if(!creditCardList){
        this.$toast.error("Error while getting credit cards");
      }
    }catch{
      this.$toast.error("Error while getting credit cards");
    }
    return creditCardList;
  },

  async fetchCustomerEmails({},{filters, pagingInfo, customerId}){
    let emailList = [];
    try{
      let filter = mapFilters(filters, pagingInfo.pageNo, pagingInfo.pageSize, pagingInfo.sortBy, pagingInfo.sortAsc);

      let url = `webpos/customer/${customerId}/emails?${new URLSearchParams(filter).toString()}`
      let result = await this.$axios.$get(url);
      if (result && !result.hasErrors) {
        emailList = result;
      }
      else{
        this.$toast.error("Error while getting customer email");
      }
    }
    catch(e){
      this.$toast.error("Error while getting customer email");
    }
    return emailList;
  },

  async fetchCustomerWishlists({}, {filter}){
    let wishlists = [];
    try{
      const result =  await this.$axios.$get(`/webpos/wishlist/items?${new URLSearchParams(filter).toString()}`)
      if(result?.apiMessages?.hasErrors){
        this.$toast.error("Error while getting customer wishlist");
        return [];
      }
      wishlists = result.value;
    }
    catch(e){
      if(e.response.status === 404){
        this.$toast.error('The selected customer does not exist');
      }
      this.$toast.error('Error while getting customer wishlist');
    }
    return wishlists;
  },

  async fetchCustomerAddresses({}, id) {
    try {
      const result = await this.$axios.$get(`webpos/customer/${id}/addresses`);
      if(!result || result.apiMessages.hasErrors){
        this.$toast.error("Error while getting customer addresses");
      }
      return result.value
    }catch (ex){
      this.$toast.error("Error while getting customer addresses");
    }
  },

  async saveCustomerAddresses({}, {customerId, customerAddresses}) {
    try {
      const result = await this.$axios.$put(`webpos/customer/${customerId}/addresses`, customerAddresses);
      if(result?.apiMessages?.hasErrors){
        this.$toast.error("Error while saving customer addresses");
        return false
      }
      else {
        this.$toast.success("Customer updated successfully");
        return true
      }
    }
    catch (ex) {
      this.$toast.error("Error while saving customer addresses")
    }
  },

  async getCustomers({}, {filters}) {
    let result = { list: [], itemCount: 0}
    try {
      let paginatedResult = await this.$axios.get('webpos/customer', { params: filters });
      if (paginatedResult && !paginatedResult.data.hasErrors && paginatedResult.data.value) {
        result.list = paginatedResult.data.value;
        result.itemCount = paginatedResult.headers['x-total-count'];
      } else {
        this.$toast.error('Error while getting customers');
      }
    }
    catch (e) {
      this.$toast.error('Error while getting customers');
    }
    return result
  },
}
